module.exports = __webpack_public_path__ + "img/Homes.3f94de0b.svg";